import { ReactElement } from 'react';
import Lang from '@lang/en';
import { Header } from '@designSystem/typings';
import {
  NoRecordsFoundContainer,
  NoRecordsImageWithMargin,
  ParagraphWithMargin,
} from '../styles';

const NoRecords = (): ReactElement => {
  return (
    <NoRecordsFoundContainer data-testid="healthcheck-dashboard-no-records-found">
      <NoRecordsImageWithMargin />
      <Header>{Lang.healthCheckNoRecordsTitleText}</Header>
      <ParagraphWithMargin>
        {Lang.healthCheckNoRecordsDetailsText}
      </ParagraphWithMargin>
    </NoRecordsFoundContainer>
  );
};

export default NoRecords;
